export default "__VITE_ASSET__c1NNbewy__"